import React from "react";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

export default function RenderConfirmDelete(props) {
  const { deleteId, handleDeleteClick, setDeleteId } = props;

  const [deleteTextBoxValue, setDeleteTextBoxValue] = React.useState("");
  const noButtonRef = React.useRef(null);

  React.useEffect(() => {
    setDeleteTextBoxValue("");
  }, [deleteId]);


  if (!deleteId) {
    return null;
  }

  const handleYes = () => {
    if (deleteTextBoxValue !== "delete") {
      noButtonRef.current.focus();
      return;
    }
    handleDeleteClick(deleteId);
    setDeleteId(null);
  };

  const handleNo = () => {
    setDeleteId(null);
  };

  const handleDeleteTextChange = (e) => setDeleteTextBoxValue(e.target.value);

  return (
    <Dialog
      maxWidth="xs"
      TransitionProps={{ onEntered: () => {} }}
      open={!!deleteId}
    >
      <DialogTitle>Are you sure?</DialogTitle>
      <DialogContent dividers>
        <Typography sx={{ fontWeight: "bold", pb: 2 }}>
          This action is irreversible.
        </Typography>
        <Typography>Type "delete" to confirm:</Typography>
        <TextField
          size="small"
          type="text"
          variant="outlined"
          value={deleteTextBoxValue}
          onChange={handleDeleteTextChange}
        />
      </DialogContent>
      <DialogActions>
        <Button ref={noButtonRef} onClick={handleNo} color="secondary">
          Cancel
        </Button>
        <Button
          onClick={handleYes}
          color="warning"
          disabled={deleteTextBoxValue !== "delete"}
          sx={{
            fontWeight: "bold",
            "&.Mui-disabled": {
              color: "primary.dark",
            },
          }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
